<div class="container-client-details" [ngClass]="{
    'component-loading': isLoading
  }">
  <ng-container *ngIf="!isLoading">
    <client-info-section [tags]="tags" [current_company]="current_company"></client-info-section>
    <people-section (removeClientUserEvent)="removeClientUser($event)" (openAddClientExistingUsersModalEvent)="
        openAddClientExistingUsersModal($event)
      " (openAddClientModalEvent)="openAddClientModal($event)" (declineEvent)="decline()"
      (openAddStaffUserModalEvent)="openAddStaffUserModal($event)"
      (unassignAccountantFromClientEvent)="unassignAccountantFromClient($event)"
      (removeInviteEvent)="removeInvite($event)" (viewInviteLinkEvent)="viewInviteLink($event)"
      (sendInviteEmailEvent)="sendInviteEmail($event)"
      (inviteContactToBecomeClientEvent)="inviteContactToBecomeClient($event)"
      (deleteContactEvent)="deleteContact($event)" [current_company]="current_company"></people-section>
  </ng-container>
</div>

<ng-template #removeClientUserConfirmation>
  <div class="modal-header text-center" style="border-bottom: none" *ngIf="user_being_removed !== null">
    <div>
      <!-- Removing any user -->
      <h4>Are you sure?</h4>
      <p>Do you want to remove this Client User from this Workspace?</p>

    <!-- Hide the buttons in case of archiving (removing last user) -->
    <div class="row">
      <div class="col-6">
        <button type="button" class="btn btn-danger pull-left btn-block"
          (click)="confirmClientUserRemoval(user_being_removed.id)">
          Remove
        </button>
      </div>
      <div class="col-6">
        <button type="button" class="btn btn-default pull-right btn-block" (click)="decline()">
          Cancel
        </button>
      </div>
    </div>
  </div>

  </div>
</ng-template>

<ng-template #removeInviteConfirmation>
  <div class="modal-body text-center rounded" *ngIf="invite_being_removed !== null">
    <div>
      <!-- Removing any user -->
      <h4>Are you sure?</h4>
      <p>
        Do you really want to remove this invite? The user will not be able to
        join this company anymore.
      </p>
    </div>

    <!-- Hide the buttons in case of archiving (removing last user) -->
    <div class="row">
      <div class="col-6">
        <button type="button" class="btn btn-danger pull-left btn-block"
          (click)="confirmInviteRemoval(invite_being_removed)">
          Remove
        </button>
      </div>
      <div class="col-6">
        <button type="button" class="btn btn-default pull-right btn-block" (click)="decline()">
          Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>